import React from 'react';
import { H1, LargeH1, LargeH2, P, typographyPropTypes } from '~typography';

var OrderConfirmation = function OrderConfirmation(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      content = _ref.content,
      color = _ref.color;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(H1, null, /*#__PURE__*/React.createElement(LargeH2, {
    colorValue: color
  }, title), /*#__PURE__*/React.createElement(LargeH1, {
    colorValue: color
  }, subtitle)), /*#__PURE__*/React.createElement(P, {
    color: color,
    lead: true,
    isBaseFont: true
  }, content));
};

OrderConfirmation.defaultProps = {
  title: undefined,
  subtitle: undefined,
  content: undefined
};
export default OrderConfirmation;